import Search from '../../Search';
const Actions = self => ({
    init: () => {
        if (self.isInitialized)
            return null;
        self.prospecting = Search.create({});
        self.search = Search.create({});
        self.isInitialized = true;
    },
    resetSearchState: () => {
        self.search = Search.create({});
    },
});
export default Actions;
